import React, {useEffect, useRef, useState} from 'react';
import {Link, useHistory, withRouter, useLocation} from "react-router-dom";
import Button from 'react-bootstrap/Button';
import {downloadAPI, getAPI, patchAPI, postAPI, putAPI} from "../APIUtil";
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import AppNav from "./AppNav";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {sortCaret} from "../MdDataTable";
import {
  addField, checkKey, dateformatDatePicker, dateformatDatePickerYYYYMM, dateformatJPNMMDD,
  dateformatJPNYYYYMMDD, dateformatYYYY_MM, dateformatYYYY_MM_DD, dateformatYYYYMM,
  finishLoadingBtn, focusById,
  formatNumber,
  isLatestVersion,
  jumpToTopByDevice, nvl, onFocusText, onKeyDownNext, onKeyDownShortCut,
  parseDate, rpad, toSingleByteNumberOnly
} from "../CMUtil";
import {Card, Col, Container, Form, InputGroup, Row} from "react-bootstrap";
import {
  faCalendar,
  faFileDownload,
} from "@fortawesome/free-solid-svg-icons";
import DatePicker, {registerLocale} from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";
import FormCheckLabel from "react-bootstrap/FormCheckLabel";
import MdDataTable from "../MdDataTable";
import {RoutePaths} from "./PageRoutesAuthenticated";

registerLocale('ja', ja)

export const PayList = () => {

  const history = useHistory();
  const {search} = useLocation();
  const iniPage = useRef(true);

  const [prvURL, setPrvURL] = useState("");

  const [loading, setLoading] = useState(true);
  const [locPage, setLocPage] = useState(null);
  const [locSizePerPage, setLocSizePerPage] = useState(100);
  const [locTotalSize, setLocTotalSize] = useState(null);
  const [locSortField, setLocSortField] = useState(null);
  const [locSortOrder, setLocSortOrder] = useState(null);
  const [cntSearch, setCntSearch] = useState(0);

  const [schedulePayMonth, setSchedulePayMonth] = useState("");
  const [isOpenSchedulePayMonth, setIsOpenSchedulePayMonth] = useState(false);

  const [payDateFrom, setPayDateFrom] = useState("");
  const [payDateTo, setPayDateTo] = useState("");
  const [payGrpNum, setPayGrpNum] = useState("");
  const [status0, setStatus0] = useState(true);
  const [status00, setStatus00] = useState(true);
  const [status01, setStatus01] = useState(true);
  const [status10, setStatus10] = useState(true);
  const [status20, setStatus20] = useState(true);
  const [status30, setStatus30] = useState(true);
  const [status90, setStatus90] = useState(true);
  const [distributionDateFrom, setDistributionDateFrom] = useState("");
  const [distributionDateTo, setDistributionDateTo] = useState("");
  const [keyword, setKeyword] = useState("");

  const [listData, setListData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  // 項目定義
  const columns = [
    {
      dataField: 'schedule_pay_month',
      text: '支払予定',
      classes: 'tbl-col text-center',
      sort: true,
      headerStyle: {width: '100px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <span>{cell ? cell.substring(0, 4) + '-' + cell.substring(4, 6) : ''}</span>
      )
    },
    {
      dataField: 'item_name',
      text: '商品名',
      classes: 'tbl-col link',
      sort: true,
      // headerStyle: {width: '230px'},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <span className="d-inline-block" tabIndex="0" data-toggle="tooltip" title={row.item_cd + ' ' + cell}>
          <a onClick={() => onClickLinkToDetail(row.pay_id, row.item_cd)}>
            {rpad(nvl(row.volume_no), 7, '\u00a0') + ' ' + row.item_cd + ' ' + cell}
          </a>
        </span>)
    },
    {
      dataField: 'cost_cd',
      text: '企画コード',
      classes: 'tbl-col text-center',
      sort: true,
      headerStyle: {width: '100px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <span className="d-inline-block" tabIndex="0" data-toggle="tooltip" title={cell}>
          {cell}
        </span>
      )
    },
    {
      dataField: 'distribution_date',
      text: '配本日',
      classes: 'tbl-col text-center',
      sort: true,
      headerStyle: {width: '130px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <span>{dateformatYYYY_MM_DD(parseDate(cell))}</span>
      )
    },
    {
      dataField: 'pay_date',
      text: '支払日',
      classes: 'tbl-col text-center',
      sort: true,
      headerStyle: {width: '100px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <span>{cell ? dateformatYYYY_MM_DD(parseDate(cell)) : ''}</span>
      )
    },
    {
      dataField: 'pay_grp_num',
      text: 'Gno',
      classes: 'tbl-col text-center',
      sort: true,
      headerStyle: {width: '70px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <span>{cell ? row.pay_grp_num : ''}</span>
      )
    },
    {
      dataField: 'status',
      text: 'ステータス',
      classes: 'tbl-col text-center col-tag-status',
      sort: true,
      headerStyle: {width: '120px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <div className={!cell ? 'd-inline-block tag-status status-0' :
          cell === '新規' ? 'd-inline-block tag-status status-00' :
            cell === '支払前' ? 'd-inline-block tag-status status-01' :
              cell === '副社長承認中' ? 'd-inline-block tag-status status-10' :
                cell === '社長承認中' ? 'd-inline-block tag-status status-20' :
                  cell === '処理中' ? 'd-inline-block tag-status status-30' :
                    cell === '支払済' ? 'd-inline-block tag-status status-90' :
                      'd-inline-block'
        } tabIndex="0">
          {cell ? cell : '未作成'}
        </div>
      )
    },
    {
      dataField: 'author_count',
      text: '支払先',
      classes: 'tbl-col',
      sort: true,
      // headerStyle: {width: '230px'},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <>
          {row.author_count &&
            <span className="d-inline-block" tabIndex="0" data-toggle="tooltip" title={row.author_nm}>
              {row.author_nm + "（" + row.author_count + "）"}
            </span>
          }
        </>
      )
    },
    {
      dataField: 'total_amount',
      text: '合計金額',
      classes: 'tbl-col text-right',
      headerStyle: {width: '100px', textAlign: "right"},
      formatter: (cell, row) => (
        <span>{formatNumber(cell)}</span>
      )
    },
  ];

  // HOOK ////////////////////////////////////////////////////////////////////////////////////

  //初期化
  useEffect(() => {

    // URLパラメータ
    const query = new URLSearchParams(search);
    const pPayDateTo = query.get("pay_date_to");
    const pPayDateFrom = query.get("pay_date_from");
    const pPayGrpNum = query.get("pay_grp_num");
    setPrvURL(query.get("prv_url"));

    // 検索履歴
    let pay_search_condition = localStorage.getItem("pay_search_condition");
    if (pPayDateFrom && pPayDateTo && pPayGrpNum){
      // URLパラメータから検索
      pPayDateFrom ? setPayDateFromSearch(pPayDateFrom) : null;
      pPayDateTo ? setPayDateToSearch(pPayDateTo) : null;
      pPayGrpNum ? setPayGrpNumSearch(pPayGrpNum) : null;

    }else if (pay_search_condition) {
      // 前回検索条件から検索
      let s = JSON.parse(pay_search_condition);
      s.schedule_pay_month ? setSchedulePayMonthSearch(s.schedule_pay_month) : null;
      s.pay_date_from ? setPayDateFromSearch(s.pay_date_from) : null;
      s.pay_date_to ? setPayDateToSearch(s.pay_date_to) : null;
      s.pay_grp_num ? setPayGrpNumSearch(s.pay_grp_num) : null;
      s.states0 ? setStatus0Search(s.states0) : null;
      s.states00 ? setStatus00Search(s.states00) : null;
      s.states01 ? setStatus01Search(s.states01) : null;
      s.distribution_date_from ? setDistributionDateFromSearch(s.distribution_date_from) : null;
      s.distribution_date_to ? setDistributionDateToSearch(s.distribution_date_to) : null;
      s.keyword ? setKeywordSearch(s.keyword) : null;
      s.page ? setLocPage(s.page) : setLocPage(1);
      s.size_per_page ? setLocSizePerPage(s.size_per_page) : null;
      s.sort_field ? setLocSortField(s.sort_field) : null;
      s.sort_order ? setLocSortOrder(s.sort_order) : null;
      s.prv_url ? setPrvURL(s.prv_url) : null;
    } else {
      setLocSortField("schedule_pay_month");
      setLocSortOrder("desc");
      setLocPage(1);
    }

    const init = async () => {
      await isLatestVersion(false);
      jumpToTopByDevice(history);
    }

    init();
  }, []);

  // 次・前ページ
  useEffect(() => {
      if (iniPage.current) {
        iniPage.current = false;
        return;
      }
      const update = async () => {
        await executeSearch(false);
      }
      update();
    },
    [
      locPage,
      cntSearch
    ]
  );

  // ロジック /////////////////////////////////////////////////////////////////////////////////

  //検索
  const executeSearch = async (isCtlEnter = false) => {
    let condition = {};
    let sortField = locSortField;
    let sortOrder = locSortOrder;

    addField(condition, "page", locPage);
    addField(condition, "size_per_page", locSizePerPage);
    addField(condition, "sort_field", sortField);
    addField(condition, "sort_order", sortOrder);
    addField(condition, "schedule_pay_month", schedulePayMonth);
    addField(condition, "pay_date_from", payDateFrom);
    addField(condition, "pay_date_to", payDateTo);
    addField(condition, "pay_grp_num", payGrpNum);
    addField(condition, "status0", status0);
    addField(condition, "status00", status00);
    addField(condition, "status01", status01);
    addField(condition, "status10", status10);
    addField(condition, "status20", status20);
    addField(condition, "status30", status30);
    addField(condition, "status90", status90);
    addField(condition, "distribution_date_from", distributionDateFrom);
    addField(condition, "distribution_date_to", distributionDateTo);
    addField(condition, "keyword", keyword);
    addField(condition, "prv_url", prvURL)

    localStorage.setItem("pay_search_condition", JSON.stringify(condition)); // 検索条件保持
    const res = await getAPI("tr_pay_search_view", condition);
    setListData(res);
    if (isCtlEnter && res.results.length > 0) {
      setSelectedId(res.results[0].row_id);
    }

    return res.results.length;
  }

  // クリア
  const onClickClear = async (e) => {
    setSchedulePayMonthSearch("");
    setPayDateFromSearch("");
    setPayDateToSearch("");
    setPayGrpNumSearch("");
    setStatus0Search(true);
    setStatus00Search(true);
    setStatus01Search(true);
    setStatus10Search(true);
    setStatus20Search(true);
    setStatus30Search(true);
    setStatus90Search(true);
    setDistributionDateFromSearch("");
    setDistributionDateToSearch("");
    setKeywordSearch("");
    setLocSortField("schedule_pay_month");
    setLocSortOrder("desc");
    localStorage.removeItem("pay_search_condition");
    setCntSearch(cntSearch + 1);
  }

  // 一覧イベント /////////////////////////////////////////////////////////////////////////////

  const onTableChange = (type, {page, sizePerPage, filters, sortField, sortOrder, cellEdit}) => {
    if ("pagination" === type) {
      setLocPage(page);
    }
    if ("sort" === type) {
      setLocSortField(sortField);
      setLocSortOrder(sortOrder);
    }
  }

  // 詳細へ遷移
  const onClickLinkToDetail = (pay_id, item_cd) => {
    if (pay_id) {
      history.push("/pay_dtl/" + pay_id + "/");
    } else {
      history.push("/pay_dtl/?item_cd=" + item_cd);
    }
  }

  // 支払い一覧ダウンロード
  const onClickDownload = async () => {

    let condition = {};
    let sortField = locSortField;
    let sortOrder = locSortOrder;

    addField(condition, "page", locPage);
    addField(condition, "size_per_page", 99999);
    addField(condition, "sort_field", sortField);
    addField(condition, "sort_order", sortOrder);
    addField(condition, "schedule_pay_month", schedulePayMonth);
    addField(condition, "pay_date_from", payDateFrom);
    addField(condition, "pay_date_to", payDateTo);
    addField(condition, "pay_grp_num", payGrpNum);
    addField(condition, "status0", status0);
    addField(condition, "status00", status00);
    addField(condition, "status01", status01);
    addField(condition, "status10", status10);
    addField(condition, "status20", status20);
    addField(condition, "status30", status30);
    addField(condition, "status90", status90);
    addField(condition, "distribution_date_from", distributionDateFrom);
    addField(condition, "distribution_date_to", distributionDateTo);
    addField(condition, "keyword", keyword);

    await downloadAPI("download/pay_list", condition);
    finishLoadingBtn("btn-download");
  }

  const setSchedulePayMonthSearch = (value) => {
    if (value > new Date(2999, 12, 31)) {
      //不正日付対応
      return;
    }
    setLocPage(1);
    setSchedulePayMonth(value);
  }

  const setPayDateFromSearch = (value) => {
    if (value > new Date(2999, 12, 31)) {
      //不正日付対応
      return;
    }
    setLocPage(1);
    setPayDateFrom(value);
  }

  const setPayDateToSearch = (value) => {
    if (value > new Date(2999, 12, 31)) {
      //不正日付対応
      return;
    }
    setLocPage(1);
    setPayDateTo(value);
  }

  const setPayGrpNumSearch = (value) => {
    setLocPage(1);
    setPayGrpNum(value);
  }

  const setStatus0Search = (value) => {
    setLocPage(1);
    setStatus0(value);
  }

  const setStatus00Search = (value) => {
    setLocPage(1);
    setStatus00(value);
  }

  const setStatus01Search = (value) => {
    setLocPage(1);
    setStatus01(value);
  }

  const setStatus10Search = (value) => {
    setLocPage(1);
    setStatus10(value);
  }

  const setStatus20Search = (value) => {
    setLocPage(1);
    setStatus20(value);
  }

  const setStatus30Search = (value) => {
    setLocPage(1);
    setStatus30(value);
  }

  const setStatus90Search = (value) => {
    setLocPage(1);
    setStatus90(value);
  }

  const setDistributionDateFromSearch = (value) => {
    if (value > new Date(2999, 12, 31)) {
      //不正日付対応
      return;
    }
    setLocPage(1);
    setDistributionDateFrom(value);
  }

  const setDistributionDateToSearch = (value) => {
    if (value > new Date(2999, 12, 31)) {
      //不正日付対応
      return;
    }
    setLocPage(1);
    setDistributionDateTo(value);
  }

  const setKeywordSearch = (value) => {
    setLocPage(1);
    setKeyword(value);
  }

  // ショートカットキー /////////////////////////////////////////////////////////////////////////////////
  // Ctl＋Shift + Enter
  const onKeyDownCtlShiftEnter = async (e) => {
    onClickClear();
    await onKeyDownEsc();
  }

  // Ctl＋Enter
  const onKeyDownCtlEnter = async (e) => {
    let count = await executeSearch(true);
    if (count === 0) {
      await focusById("schedulePayMonth");
      return;
    }
    await focusById("data-table");
  }

  // Escape
  const onKeyDownEsc = async (e) => {
    if(e.target.id === "schedulePayMonth" && prvURL) {
      history.push(prvURL);
    }
    setSelectedId("");
    await focusById("schedulePayMonth");
  }

  // Space
  const onKeyDownSpace = async (e) => {
    //無効化
  }

  // Enter
  const onKeyDownEnter = async (e) => {
    if (e && e.target && (e.target.tagName === "INPUT")) {
      await onKeyDownNext(e);
    }
  }

  // ショートカットキー:一覧用 /////////////////////////////////////////////////////////////////////////////////
  // Ctl＋Enter
  const onKeyDownCtlEnterDataList = async (e) => {
    let cPayId = e.selected[0].split("_")[1];
    let cItemId = e.selected[0].split("_")[0];
    onClickLinkToDetail(cPayId, cItemId);
  }

  // Escape
  const onKeyDownEscDataList = async (e) => {
    await onKeyDownEsc(e);
  }

  const onKeyDownSpaceDataList = async (e) => {
    let cPayId = e.selected[0].split("_")[1];
    let cItemId = e.selected[0].split("_")[0];
    onClickLinkToDetail(cPayId, cItemId);
  }


  // カレンダー用 ////////////////////////////////////////////////////////////////////////////////////////
  const [openCalSchedulePayMonth, setOpenCalSchedulePayMonth] = useState(false);
  const handleChangeCalSchedulePayMonth = async (dateObj) => {
    setSchedulePayMonth(dateformatYYYY_MM(dateObj))
    setOpenCalSchedulePayMonth(false);
    await focusById("schedulePayMonth");
  };

  const [openCalPayDateFrom, setOpenCalPayDateFrom] = useState(false);
  const handleChangeCalPayDateFrom = async (dateObj) => {
    setPayDateFrom(dateformatYYYY_MM_DD(dateObj))
    setOpenCalPayDateFrom(false);
    await focusById("payDateFrom");
  };

  const [openCalPayDateTo, setOpenCalPayDateTo] = useState(false);
  const handleChangeCalPayDateTo = async (dateObj) => {
    setPayDateTo(dateformatYYYY_MM_DD(dateObj))
    setOpenCalPayDateTo(false);
    await focusById("payDateTo");
  };

  const [openCalDistributionDateFrom, setOpenCalDistributionDateFrom] = useState(false);
  const handleChangeCalDistributionDateFrom = async (dateObj) => {
    setDistributionDateFrom(dateformatYYYY_MM_DD(dateObj))
    setOpenCalDistributionDateFrom(false);
    await focusById("distributionDateFrom");
  };

  const [openCalDistributionDateTo, setOpenCalDistributionDateTo] = useState(false);
  const handleChangeCalDistributionDateTo = async (dateObj) => {
    setDistributionDateTo(dateformatYYYY_MM_DD(dateObj))
    setOpenCalDistributionDateTo(false);
    await focusById("distributionDateTo");
  };

  return (
    <>
      <AppNav/>
      <div
        onKeyDown={(e) => onKeyDownShortCut(e, () => onKeyDownCtlShiftEnter(e), () => onKeyDownCtlEnter(e), () => onKeyDownEsc(e), () => onKeyDownSpace(e), () => onKeyDownEnter(e))}
      >
        <Row className="h1" style={{maxWidth: "1400px"}}>
          <Col sm={11}>
            <h1>
              ギャラ支払一覧
            </h1>
          </Col>
          <Col sm={1}>
            {prvURL &&
              <Button as={Link} to={prvURL} variant="quaternary" className="mr-4">
                戻る
              </Button>
            }
          </Col>
        </Row>
        <Card className="pay-list-card-search" style={{maxWidth: "1400px"}}>
          <Container className="container-main-search">
            <Form.Group as={Row}>
              <Form.Label column sm="1">支払予定</Form.Label>
              <Col sm="2" className="input-group date-picker-month-year">
                <div className="input-group">
                  <Form.Control
                    id="schedulePayMonth"
                    type="text"
                    className="text-center"
                    tabIndex={10}
                    value={schedulePayMonth}
                    onKeyPress={e => checkKey(e, /^[\d-]+$/)}
                    onChange={e => setSchedulePayMonth(e.target.value)}
                    onFocus={e => onFocusText(e)}
                    onBlur={e => setSchedulePayMonth(dateformatYYYY_MM(dateformatDatePickerYYYYMM(e.target.value)))}
                    autoFocus={true}
                  />
                  <button
                    type="button"
                    onClick={e => setOpenCalSchedulePayMonth(true)}
                    style={{
                      position: "absolute",
                      top: "0.4rem",
                      right: "0.2rem",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      zIndex: 5
                    }}>
                    <FontAwesomeIcon icon={faCalendar}/>
                  </button>
                </div>
                <DatePicker
                  wrapperClassName="display-none-date-wrapper"
                  selected={dateformatDatePicker(toSingleByteNumberOnly(schedulePayMonth))}
                  onChange={handleChangeCalSchedulePayMonth}
                  open={openCalSchedulePayMonth}
                  onClickOutside={e => setOpenCalSchedulePayMonth(false)}
                  customInput={<div style={{display: "none"}}/>}
                  dateFormat="yyyy-MM"
                  popperPlacement="bottom-start"
                  showMonthYearPicker
                  disabledKeyboardNavigation
                  locale="ja"
                />
              </Col>
              <Col sm="1"></Col>
              <Form.Label column sm="1">支払日</Form.Label>
              <Col sm="5" className="input-group">
                <div className="input-group" style={{width: "163px"}}>
                  <Form.Control
                    id="payDateFrom"
                    type="text"
                    className="text-center"
                    inputMode="numeric"
                    tabIndex={11}
                    value={payDateFrom}
                    onKeyPress={e => checkKey(e, /^[\d-]+$/)}
                    onChange={e => setPayDateFrom(e.target.value)}
                    onFocus={e => onFocusText(e)}
                    onBlur={e => setPayDateFrom(dateformatYYYY_MM_DD(dateformatDatePicker(e.target.value)))}
                  />
                  <button
                    type="button"
                    onClick={e => setOpenCalPayDateFrom(true)}
                    style={{
                      position: "absolute",
                      top: "0.4rem",
                      right: "0.2rem",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      zIndex: 5
                    }}>
                    <FontAwesomeIcon icon={faCalendar}/>
                  </button>
                </div>
                <DatePicker
                  wrapperClassName="display-none-date-wrapper"
                  selected={dateformatDatePicker(toSingleByteNumberOnly(payDateFrom))}
                  onChange={handleChangeCalPayDateFrom}
                  open={openCalPayDateFrom}
                  onClickOutside={e => setOpenCalPayDateFrom(false)}
                  customInput={<div style={{display: "none"}}/>}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom-start"
                  disabledKeyboardNavigation
                  locale="ja"
                />
                <InputGroup.Text style={{border: "0px", backgroundColor: "#ffffff"}}>～</InputGroup.Text>
                <div className="input-group" style={{width: "163px"}}>
                  <Form.Control
                    id="payDateTo"
                    type="text"
                    className="text-center"
                    inputMode="numeric"
                    tabIndex={12}
                    value={payDateTo}
                    onKeyPress={e => checkKey(e, /^[\d-]+$/)}
                    onChange={e => setPayDateTo(e.target.value)}
                    onFocus={e => onFocusText(e)}
                    onBlur={e => setPayDateTo(dateformatYYYY_MM_DD(dateformatDatePicker(e.target.value)))}
                  />
                  <button
                    type="button"
                    onClick={e => setOpenCalPayDateTo(true)}
                    style={{
                      position: "absolute",
                      top: "0.4rem",
                      right: "0.2rem",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      zIndex: 5
                    }}>
                    <FontAwesomeIcon icon={faCalendar}/>
                  </button>
                </div>
                <DatePicker
                  selected={dateformatDatePicker(toSingleByteNumberOnly(payDateTo))}
                  onChange={handleChangeCalPayDateTo}
                  open={openCalPayDateTo}
                  onClickOutside={e => setOpenCalPayDateTo(false)}
                  customInput={<div style={{display: "none"}}/>}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom-start"
                  disabledKeyboardNavigation
                  locale="ja"
                />
              </Col>
              <Form.Label column sm="1">Gno</Form.Label>
              <Col sm="1" className="input-group">
                <Form.Control
                  type="text"
                  tabIndex={14}
                  value={payGrpNum}
                  onChange={e => setPayGrpNumSearch(e.target.value)}
                  onFocus={e => onFocusText(e)}/>
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm="1">検索</Form.Label>
              <Col sm="3" className="input-group">
                <Form.Control
                  id="keyword"
                  type="text"
                  tabIndex={16}
                  value={keyword}
                  onChange={e => setKeywordSearch(e.target.value)}
                  onFocus={e => onFocusText(e)}/>
              </Col>
              <Form.Label column sm="1">配本日</Form.Label>
              <Col sm="5" className="input-group">
                <div className="input-group" style={{width: "163px"}}>
                  <Form.Control
                    id="distributionDateFrom"
                    type="text"
                    className="text-center"
                    inputMode="numeric"
                    tabIndex={18}
                    value={distributionDateFrom}
                    onKeyPress={e => checkKey(e, /^[\d-]+$/)}
                    onChange={e => setDistributionDateFrom(e.target.value)}
                    onFocus={e => onFocusText(e)}
                    onBlur={e => setDistributionDateFrom(dateformatYYYY_MM_DD(dateformatDatePicker(e.target.value)))}
                  />
                  <button
                    type="button"
                    onClick={e => setOpenCalDistributionDateFrom(true)}
                    style={{
                      position: "absolute",
                      top: "0.4rem",
                      right: "0.2rem",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      zIndex: 5
                    }}>
                    <FontAwesomeIcon icon={faCalendar}/>
                  </button>
                </div>
                <DatePicker
                  wrapperClassName="display-none-date-wrapper"
                  selected={dateformatDatePicker(toSingleByteNumberOnly(distributionDateFrom))}
                  onChange={handleChangeCalDistributionDateFrom}
                  open={openCalDistributionDateFrom}
                  onClickOutside={e => setOpenCalDistributionDateFrom(false)}
                  customInput={<div style={{display: "none"}}/>}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom-start"
                  disabledKeyboardNavigation
                  locale="ja"
                />
                <InputGroup.Text style={{border: "0px", backgroundColor: "#ffffff"}}>～</InputGroup.Text>
                <div className="input-group" style={{width: "163px"}}>
                  <Form.Control
                    id="distributionDateTo"
                    type="text"
                    className="text-center"
                    inputMode="numeric"
                    tabIndex={20}
                    value={distributionDateTo}
                    onKeyPress={e => checkKey(e, /^[\d-]+$/)}
                    onChange={e => setDistributionDateTo(e.target.value)}
                    onFocus={e => onFocusText(e)}
                    onBlur={e => setDistributionDateTo(dateformatYYYY_MM_DD(dateformatDatePicker(e.target.value)))}
                  />
                  <button
                    type="button"
                    onClick={e => setOpenCalDistributionDateTo(true)}
                    style={{
                      position: "absolute",
                      top: "0.4rem",
                      right: "0.2rem",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      zIndex: 5
                    }}>
                    <FontAwesomeIcon icon={faCalendar}/>
                  </button>
                </div>
                <DatePicker
                  selected={dateformatDatePicker(toSingleByteNumberOnly(distributionDateTo))}
                  onChange={handleChangeCalDistributionDateTo}
                  open={openCalDistributionDateTo}
                  onClickOutside={e => setOpenCalDistributionDateTo(false)}
                  customInput={<div style={{display: "none"}}/>}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom-start"
                  disabledKeyboardNavigation
                  locale="ja"
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm="1">状態</Form.Label>
              <Col sm="8" className="input-group">
                <FormCheckLabel className={status0 ? 'form-check-label-checked-0' : ''}>
                  <Form.Check
                    type="checkbox"
                    style={{marginRight: "1rem", display: "none"}}
                    onChange={e => setStatus0Search(!status0)}
                    checked={status0}/>
                  未作成
                </FormCheckLabel>
                <FormCheckLabel className={status01 ? "form-check-label-checked-01" : ""}>
                  <Form.Check
                    type="checkbox"
                    style={{marginRight: "1rem", display: "none"}}
                    onChange={e => setStatus01Search(!status01)}
                    checked={status01}/>
                  支払前
                </FormCheckLabel>
                <FormCheckLabel className={status30 ? "form-check-label-checked-30" : ""}>
                  <Form.Check
                    type="checkbox"
                    style={{marginRight: "1rem", display: "none"}}
                    onChange={e => setStatus30Search(!status30)}
                    checked={status30}/>
                  処理中
                </FormCheckLabel>
                <FormCheckLabel className={status90 ? "form-check-label-checked-90" : ""}>
                  <Form.Check
                    type="checkbox"
                    style={{marginRight: "1rem", display: "none"}}
                    onChange={e => setStatus90Search(!status90)}
                    checked={status90}/>
                  支払済
                </FormCheckLabel>
              </Col>
            </Form.Group>
            <Form.Group as={Row} style={{marginTop: "1rem"}}>
              <Col></Col>
              <Col sm="11" className="d-flex justify-content-start">
                <Button variant="primary" style={{marginRight: "3rem"}} onClick={e => executeSearch(e)}>検索</Button>
                <Button variant="clear" onClick={e => onClickClear(e)}>クリア</Button>
              </Col>
            </Form.Group>
          </Container>
        </Card>

        {/*<Card style={{border: "none"}}>*/}
        {/*  <Container className="container-main-button-area">*/}
        {/*    <Row>*/}
        {/*      <Col style={{textAlign: "right"}}>*/}
        {/*        <Button variant="secondary" id="btn-download" onClick={e => onClickDownload()}>*/}
        {/*        <span>*/}
        {/*        <FontAwesomeIcon icon={faFileDownload} size="lg"/>支払一覧*/}
        {/*        </span>*/}
        {/*        </Button>*/}
        {/*      </Col>*/}
        {/*    </Row>*/}
        {/*  </Container>*/}
        {/*</Card>*/}

        <Container className="container-main-list">
          {/* *** 一覧 *** */}
          {/*<InitialLoading loadingCss={loadingCss}/>*/}
          <MdDataTable
            // tableRef={tableRef}
            keyField="row_id"
            listData={listData}
            columns={columns}
            loading={loading}
            onTableChange={onTableChange}
            page={locPage}
            sizePerPage={locSizePerPage}
            // selectRowProp={selectRowProp}
            // selected={selectedPayNos}
            totalSize={locTotalSize}
            sortField={locSortField}
            sortOrder={locSortOrder}
            showPagenation={true}
            // linkToAdd="/pay/"
            onClickLinkToDetail={onClickLinkToDetail}
            selectedRowId={selectedId}
            onKeyDownCtlEnterDataList={e => onKeyDownCtlEnterDataList(e)}
            onKeyDownEscDataList={e => onKeyDownEscDataList(e)}
            onKeyDownSpaceDataList={e => onKeyDownSpaceDataList(e)}
          />
        </Container>
      </div>
    </>
  );
}

export default withRouter(PayList);